import React from 'react';
import { COMPLIANCE_LABEL, COMPLIANCE_CLASS } from '@/lib/employees/service';

export const ComplianceBadge = ({ status, issues, testId }) => (
  <span data-testid={testId} className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[11px] uppercase tracking-wider ${COMPLIANCE_CLASS[status] || COMPLIANCE_CLASS.compliant}`}>
    {COMPLIANCE_LABEL[status] || status}{issues > 0 ? ` · ${issues}` : ''}
  </span>
);

export const daysTo = (iso) => (iso ? Math.ceil((new Date(iso) - new Date()) / 86400000) : null);

export const ExpiryText = ({ expiry }) => {
  if (!expiry) return <span className="text-muted-foreground">No expiry</span>;
  const d = daysTo(expiry);
  if (d < 0) return <span className="text-red-700 font-medium">Expired {Math.abs(d)} d ago</span>;
  if (d <= 30) return <span className="text-amber-700 font-medium">Expires in {d} d</span>;
  return <span>{d} d remaining</span>;
};
